import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const STATUSES = ["new", "contacted", "won", "lost"];
const TONE = { new: "bg-amber-100 text-amber-800", contacted: "bg-sky-100 text-sky-800", won: "bg-emerald-100 text-emerald-800", lost: "bg-zinc-200 text-zinc-700" };

export const ProposalsTab = () => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/proposals").then((r) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const setStatus = async (p, status) => {
    try { await api.post(`/admin/proposals/${p.id}/status`, { status }); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (!rows.length) return <div className="card-warm p-6 text-sm text-zinc-500" data-testid="proposals-empty">No proposal requests yet. They arrive from the For Organisations page.</div>;
  return (
    <div className="space-y-3" data-testid="admin-proposals-tab">
      {rows.map((p) => (
        <div key={p.id} className="card-warm p-4 flex flex-wrap items-start justify-between gap-3" data-testid={`proposal-${p.id}`}>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <b>{p.company}</b>
              <span className={`text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5 ${TONE[p.status]}`}>{p.status}</span>
              <span className="text-xs text-zinc-500">{(p.created_at || "").slice(0, 10)}</span>
            </div>
            <div className="text-sm text-zinc-700 mt-1 break-words">{p.contact_name} · <a href={`mailto:${p.email}`} className="underline">{p.email}</a> · {p.country}</div>
            <div className="text-xs text-zinc-600 mt-1">Programmes: {(p.programmes || []).join(", ") || "Not specified"} · Staff: {p.staff_count}</div>
            {p.message && <p className="text-sm text-zinc-700 mt-2 whitespace-pre-wrap break-words">{p.message}</p>}
          </div>
          <select value={p.status} onChange={(e) => setStatus(p, e.target.value)} className="field text-xs w-36" data-testid={`proposal-status-${p.id}`}>
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
};
